import React from 'react';
import './ImageStyleSheet.css';

function ImageInkOne() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/7ink1.jpg" className='img-view'/>
        </div>
    )
}

export default ImageInkOne
